import { useEffect, useState } from 'react';

import "./styles/base.css";
import "./styles/display.css";

export default function QuizDisplay({
  quizId,
  question,
  options,
  correctOption,
  onAnswer,
  onEditClick,
  previewMode = false, // controls action-button UI
  disableSelection = false, // when true, user cannot select even if readOnly===false
  initialHasAnswered = false,
  userAnswer = null, // Accept userAnswer as a prop
  hasAnybodyAnswered = false,
}) {
  // preview‐mode (show correct answer immediately, before a user has answered)
  const isPreview = !onAnswer;
  const canEdit = !previewMode && Boolean(onEditClick) && !hasAnybodyAnswered;

  // Local state (we’ll sync it with props on every change)
  const [selectedIdx, setSelectedIdx] = useState(null);
  const [hasAnswered, setHasAnswered] = useState(false);

  // Sync internal state whenever the incoming props change

  useEffect(() => {
    setSelectedIdx(initialHasAnswered ? userAnswer : null);
    setHasAnswered(initialHasAnswered);
  }, [initialHasAnswered, userAnswer]);

  const handleAnswer = async (idx) => {
    if (!onAnswer) return;
    try {
      await onAnswer(quizId, idx);
    } catch (err) {
      // already answered, etc
    }
    setSelectedIdx(idx);
    setHasAnswered(true);
  };

  return (
    <div
      className={`quiz-wrapper post-embedded-block${isPreview ? " preview-mode" : ""}`}
      contentEditable={false}
    >
      <div
        className={`quiz-container${canEdit ? ' quiz-container--editable' : ''}`}
        {...(canEdit ? {
          role: 'button',
          tabIndex: 0,
          'aria-label': 'Edit quiz',
          onClick: onEditClick,
          onKeyDown: event => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              onEditClick();
            }
          }
        } : {})}
      >
        {/* Quiz Question */}
        <h3 className="quiz-title">{question}</h3>

        {/* Quiz Options */}

        <div className="quiz-options-container">
          {options.map((option, index) => {
            let cls = '';
            if (hasAnswered) {
              if (index === correctOption) cls = ' option-correct';
              else if (index === selectedIdx) cls = ' option-wrong';
            } else if (isPreview) {
              // in preview (pre‐submit), highlight correct answer
              if (index === correctOption) cls = ' option-correct';
            }

            return (
              <div
                key={index}
                className={`quiz-option${cls}`}
                onClick={e => {
                  if (canEdit) return;
                  e.stopPropagation(); // Prevent click from bubbling up
                  if (!previewMode && !disableSelection && !hasAnswered) {
                    handleAnswer(index);
                  }
                }}
              >
                <div className="submitted-quiz-option-input">
                  <div className="quiz-option-content">
                    <span className="quiz-option-circle">
                      {String.fromCharCode(65 + index)}
                    </span>
                    <span className="quiz-option-text">{option}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
